<template>
  <div class="abe-wrapper">
    <call-test-list
      :data="items"
      :server-ip="dataParams.ip"
      :server-port="dataParams.serverport"
    ></call-test-list>
    <call-test-dialog ref="callTestDialog"></call-test-dialog>
  </div>
</template>

<script>
import callTestList from './callTestList.vue'
import callTestDialog from './callTestDialog.vue'
import genKeyIcon from '@/assets/images/excellent/gen-key-icon.png'
import centerGenKeyIcon from '@/assets/images/excellent/center-gen-key-icon.png'
import centerGetKeyIcon from '@/assets/images/excellent/center-get-key-icon.png'
import genUserKeyIcon from '@/assets/images/excellent/gen-user-key-icon.png'
import encipherIcon from '@/assets/images/excellent/encipher-icon.png'
import decryptIcon from '@/assets/images/excellent/decrypt-icon.png'
export default {
  name: 'Abe',
  components: {
    callTestList,
    callTestDialog
  },
  props: {
    dataObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      items: [
        {
          name: '获取系统公钥',
          url: '/encrypt/abe/sys/pubkey',
          icon: genKeyIcon,
          title: '获取系统公钥',
          formItems: [
            {
              prop: 'display',
              label: '系统公钥',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            display: undefined
          },
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '获取系统公钥',
              isLoading: false,
              click: this.genSystemPublicKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '属性中心生成密钥',
          url: '/encrypt/abe/attrcenter/generate',
          icon: centerGenKeyIcon,
          title: '属性中心生成密钥',
          formItems: [
            {
              prop: 'attrs',
              label: '属性',
              type: 'textarea',
              isArray: true,
              placeholder: '请输入属性',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '返回密钥',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            attrs: [{ value: '' }],
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '添加属性',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.attrs.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genAttrCenterKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '获取属性中心公钥',
          url: '/encrypt/abe/attrcenter/pubkey',
          icon: centerGetKeyIcon,
          title: '获取属性中心公钥',
          formItems: [
            {
              prop: 'display',
              label: '属性中心公钥',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            display: undefined
          },
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '获取属性中心公钥',
              isLoading: false,
              click: this.genAttrCenterPublicKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '生成用户密钥',
          url: '/encrypt/abe/user/generate',
          icon: genUserKeyIcon,
          title: '生成用户密钥',
          formItems: [
            {
              prop: 'attrs',
              label: '属性',
              type: 'textarea',
              isArray: true,
              placeholder: '请输属性',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'gid',
              label: '用户ID',
              type: 'textarea',
              placeholder: '请输入用户ID',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '返回密钥',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            attrs: [{ value: '' }],
            gid: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '添加属性',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.attrs.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genUserKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '属性加密',
          url: '/encrypt/abe/encrypt',
          icon: encipherIcon,
          title: '属性加密',
          formItems: [
            {
              prop: 'policy',
              label: '策略',
              type: 'textarea',
              placeholder: '请输入策略',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'text',
              label: '加密内容',
              type: 'textarea',
              placeholder: '请输入加密内容',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '加密文本',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            policy: undefined,
            text: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.encipher
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '属性解密',
          url: '/encrypt/abe/decrypt',
          icon: decryptIcon,
          title: '属性解密',
          formItems: [
            {
              prop: 'priKey',
              label: '用户私钥',
              type: 'textarea',
              secret: true,
              placeholder: '请输入用户私钥',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'cipher',
              label: '密文',
              type: 'textarea',
              secret: true,
              placeholder: '请输入密文',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '返回解密',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            priKey: undefined,
            cipher: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.decrypt
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        }
      ],
      dataParams: {}
    }
  },
  created() {
    this.dataParams = this.dataObj
  },
  methods: {
    callTestHandle(data) {
      data.ip = this.dataParams.ip
      data.port = this.dataParams.serverport
      this.$refs.callTestDialog.handleOpen(data)
    },
    genSystemPublicKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          self.$apis.excellent
            .formSysPubkey(`http://${data.ip}:${data.port}${data.url}`)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.sys_pub_key
                data.displayState['display'] = false
                self.$message.success('生成系统公钥成功！')
              } else {
                self.$message.error('生成系统公钥失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('生成系统公钥失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    genAttrCenterKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let attrs = []
          model.attrs.forEach(e => {
            let attr = e.replace(/[\r\n]/g, '')
            attrs.push(attr)
          })
          if (this.hasDuplicates(attrs)) {
            this.$message.error('属性值有重复，请重新输入！')
            item.isLoading = false
          } else {
            let params = JSON.stringify(model)
            self.$apis.excellent
              .formAttrcenterGenerate(`http://${data.ip}:${data.port}${data.url}`, params)
              .then(res => {
                if (res.code == 0 && res.data) {
                  data.formModel.display = res.data.ac_pub_key
                  data.displayState['display'] = false
                  self.$message.success('生成密钥成功！')
                } else {
                  self.$message.error('生成密钥失败！' + res.message)
                }
                item.isLoading = false
              })
              .catch(err => {
                self.$message.error('生成密钥失败！')
                item.isLoading = false
              })
          }
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    genAttrCenterPublicKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          self.$apis.excellent
            .formSysPubkey(`http://${data.ip}:${data.port}${data.url}`)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.ac_pub_key
                data.displayState['display'] = false
                self.$message.success('生成属性中心公钥成功！')
              } else {
                self.$message.error('生成属性中心公钥失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('生成属性中心公钥失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    genUserKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let attrs = []
          model.attrs.forEach(e => {
            let attr = e.replace(/[\r\n]/g, '')
            attrs.push(attr)
          })
          if (this.hasDuplicates(attrs)) {
            this.$message.error('属性值有重复，请重新输入！')
            item.isLoading = false
          } else {
            let params = JSON.stringify(model)
            self.$apis.excellent
              .formUserGenerate(`http://${data.ip}:${data.port}${data.url}`, params)
              .then(res => {
                if (res.code == 0 && res.data) {
                  data.formModel.display = res.data.user_pri_key
                  data.displayState['display'] = false
                  self.$message.success('生成用户密钥成功！')
                } else {
                  self.$message.error('生成用户密钥失败！' + res.message)
                }
                item.isLoading = false
              })
              .catch(err => {
                self.$message.error('生成用户密钥失败！')
                item.isLoading = false
              })
          }
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    encipher(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formAttrEncrypt(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.cipher
                data.displayState['display'] = false
                self.$message.success('加密成功！')
              } else {
                self.$message.error('加密失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('加密失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    decrypt(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formAttrDecrypt(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.text
                data.displayState['display'] = false
                self.$message.success('解密成功！')
              } else {
                self.$message.error('解密失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('解密失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    //判断数组中是否有重复元素
    hasDuplicates(array) {
      return new Set(array).size !== array.length
    }
  }
}
</script>
<style scoped lang="scss"></style>
